// extracted by mini-css-extract-plugin
export default {"voice_message":"styles_voice_message__F98U-"};